import { SvgProps } from "components/icons/types";

export const CornerDownRight = (props: SvgProps) => (
  <svg
    width="18"
    height="27"
    viewBox="0 0 18 25.5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.5 0V19C0.5 22.3137 3.18629 25 6.5 25H18"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
